<template>
    <div class="container">
        <b-modal
            :model-value="showCreaNivCuatro"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            size="lg"
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ labels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.nivelUno }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            :value="nivelUnoSelect"
                            class="form-input"
                            disabled
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.nivelDos }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            :value="nivelDosSelect"
                            class="form-input"
                            disabled
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.nivelTres }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            :value="nivelTresSelect"
                            class="form-input"
                            disabled
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.nivelCuatro }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="numeroNivel"
                            type="text"
                            class="form-input"
                            :placeholder="labels.nivelPlaceholder"
                            @input="onChange"
                        />
                    </b-col>
                </b-row>

                <b-row class="d-flex align-items-center uniform-form-row">
                    <b-col cols="12" md="4" class="text-left uniform-label-col">
                        <label class="form-label">{{ labels.descripcion }}</label>
                    </b-col>
                    <b-col cols="12" md="8" class="text-left">
                        <b-form-input 
                            v-model="descripcion"
                            type="text"
                            class="form-input"
                            :placeholder="labels.descripcionPlaceholder"
                            @input="onChange"
                        />
                    </b-col>
                </b-row>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="closeDialog">
                        {{ labels.close }}
                    </b-button>
                    <b-button 
                        class="reset-btn-primary ml-2" 
                        @click="confirmSave"
                        :disabled="!hasUnsavedChanges || isLoading || !numeroNivel || !descripcion"
                    >
                        <b-spinner v-if="isLoading" small class="mr-1"></b-spinner>
                        {{ labels.save }}
                    </b-button>
                </div>
            </div>
        </b-modal>

        <b-modal
            :model-value="showConfirmModal"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            size="md"
            :title="confirmLabels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ confirmLabels.infoTitle }}</div>
                    <div class="password-policy-subtitle">{{ confirmLabels.infoText }}</div>
                </div>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="closeConfirmModal">
                        {{ confirmLabels.cancel }}
                    </b-button>
                    <b-button class="reset-btn-primary ml-2" @click="executeAction">
                        {{ confirmLabels.confirm }}
                    </b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import Nivel from '../../services/Nivel' 

export default {
    name: "CreaNivelCuatro",
    props: {
        showCreaNivCuatro: {
            type: Boolean,
            default: false
        },
        nivelUnoSelect: {
            type: String,
            default: ""
        },
        nivelDosSelect: {
            type: String,
            default: ""
        },
        nivelTresSelect: {
            type: String,
            default: ""
        },
        codReporte: {
            type: String,
            default: ""
        }
    },
    data: () => ({
        numeroNivel: "",
        descripcion: "",
        hasUnsavedChanges: false,
        isLoading: false,
        showConfirmModal: false,
        pendingAction: null,
        originalData: {
            numeroNivel: "",
            descripcion: ""
        }
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Crear Nivel 4",
                    infoTitle: "Nuevo Nivel 4",
                    infoText: "Ingresa los datos del nuevo nivel 4 y guarda los cambios.",
                    nivelUno: "Nivel I:",
                    nivelDos: "Nivel II:",
                    nivelTres: "Nivel III:",
                    nivelCuatro: "Nivel IV:",
                    nivelPlaceholder: "Ingrese el código del nivel (Ej: 1.1.1.1, 1.1.1.2...)",
                    descripcion: "Descripción:",
                    descripcionPlaceholder: "Ingrese la descripción del nivel",
                    save: "Guardar",
                    close: "Cerrar"
                }
            } else {
                return {
                    title: "Create Level 4",
                    infoTitle: "New Level 4",
                    infoText: "Enter the new level 4 data and save the changes.",
                    nivelUno: "Level I:",
                    nivelDos: "Level II:",
                    nivelTres: "Level III:",
                    nivelCuatro: "Level IV:",
                    nivelPlaceholder: "Enter level code (Eg: 1.1.1.1, 1.1.1.2...)",
                    descripcion: "Description:",
                    descripcionPlaceholder: "Enter level description",
                    save: "Save",
                    close: "Close"
                }
            }
        },
        confirmLabels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Confirmar acción",
                    infoTitle: "¿Está seguro?",
                    infoText: this.pendingAction === 'save' 
                        ? "¿Está seguro que desea crear este nivel 4?" 
                        : "¿Está seguro que desea cerrar sin guardar los cambios?",
                    confirm: "Confirmar",
                    cancel: "Cancelar"
                }
            } else {
                return {
                    title: "Confirm action",
                    infoTitle: "Are you sure?",
                    infoText: this.pendingAction === 'save' 
                        ? "Are you sure you want to create this level 4?" 
                        : "Are you sure you want to close without saving?",
                    confirm: "Confirm",
                    cancel: "Cancel"
                }
            }
        }
    },
    watch: {
        showCreaNivCuatro: {
            handler(newVal) {
                if (newVal) {
                    this.isLoading = false
                    this.hasUnsavedChanges = false
                    this.numeroNivel = ""
                    this.descripcion = ""
                    this.pendingAction = null
                    this.saveOriginalData()
                }
            },
            immediate: true
        },
        numeroNivel() { 
            this.hasUnsavedChanges = this.checkChanges() 
        },
        descripcion() { 
            this.hasUnsavedChanges = this.checkChanges() 
        }
    },
    methods: {
        saveOriginalData() {
            this.originalData = {
                numeroNivel: "",
                descripcion: ""
            }
        },
        checkChanges() {
            return this.numeroNivel !== this.originalData.numeroNivel ||
                   this.descripcion !== this.originalData.descripcion
        },
        onChange() {
            this.hasUnsavedChanges = this.checkChanges()
        },
        clearCampos() {
            this.numeroNivel = ""
            this.descripcion = ""
            this.hasUnsavedChanges = false
            this.pendingAction = null
        },
        closeDialog() {
            if (this.hasUnsavedChanges) {
                this.pendingAction = 'close'
                this.showConfirmModal = true
            } else {
                this.closeModal()
            }
        },
        confirmSave() {
            if (this.numeroNivel == "") {
                this.$toast.error("El campo Nivel debe estar diligenciado")
                return
            }
            if (this.descripcion == "") {
                this.$toast.error("El campo Descripción debe estar diligenciado")
                return
            }
            this.pendingAction = 'save'
            this.showConfirmModal = true
        },
        closeConfirmModal() {
            this.showConfirmModal = false
            this.pendingAction = null
        },
        executeAction() {
            this.showConfirmModal = false
            const action = this.pendingAction
            this.pendingAction = null

            if (action === 'save') {
                this.guardaNivel()
            } else if (action === 'close') {
                this.closeModal()
            }
        },
        closeModal() {
            this.$emit("closeModal", false)
            this.clearCampos()
        },
        guardaNivel() {
            this.isLoading = true
            
            // Extraer solo los códigos (sin la descripción)
            const nivelUnoCodigo = this.nivelUnoSelect.split(' - ')[0] || this.nivelUnoSelect
            const nivelDosCodigo = this.nivelDosSelect.split(' - ')[0] || this.nivelDosSelect
            const nivelTresCodigo = this.nivelTresSelect.split(' - ')[0] || this.nivelTresSelect
            
            const info = {
                'numNivelUno': nivelUnoCodigo,
                'numNivelDos': nivelDosCodigo,
                'numNivelTres': nivelTresCodigo,
                'numNivelCuatro': this.numeroNivel,
                'descripcion': this.descripcion,
                'codReporte': this.codReporte,
                'idUser': this.$store.state.userId
            }
            
            const service = this.$route.params.tipo == 'directo' 
                ? Nivel.crearNivelCuatroEfe 
                : Nivel.crearNivelCuatroEfeInd
            
            service(info) 
                .then((res) => { 
                    this.$toast.success(res.data.message)
                    this.refrescaNivel()
                })
                .catch((err) => { 
                    console.error(err) 
                    if (err.response?.status == 500 || err.response?.status == 412) { 
                        this.$toast.error(err.response.data.message)
                    } else {
                        this.$toast.error("Algo pasó, intentalo de nuevo")
                    }
                    this.isLoading = false
                })
        },
        refrescaNivel() {
            this.clearCampos()
            this.isLoading = false
            this.$emit('refresNivelCuatro', this.$route.params.tipo)
            this.$emit('closeModal', false)
        }
    }
}
</script>

<style src="../main.css"></style>